// SearchableMultiSelect.js
import React, { useState, useEffect, useRef } from "react";
import {
  Checkbox,
  TextField,
  FormControl,
  Autocomplete,
  Box,
} from "@mui/material";
import axios from "axios";
import { debounce } from "lodash";
import { BASE_URL } from "../../../config/apiConfig";
import { getHeaders } from "../../../utils/apiUtils";
import { showAlert } from "../../common/userFeedback/CustomAlert";

const PipelineJobMultiSelect = ({
  selected,
  onSelectedChange,
  label,
  sx={},
  jobNames = ["manual_image_tagging"],
  pipelineIds = null,
  showIsArchived=false,
  pipelineJobs=null,
  width=300
}) => {
  const [options, setOptions] = useState([]);
  const componentRef = useRef(); // Create a ref for the component

  // Function to fetch filtered options from the database
  const fetchJobs = async () => {
    let pipelineJobsTemp = pipelineJobs
    if (pipelineJobsTemp)
    {
      if (jobNames && jobNames.length > 0) {
        pipelineJobsTemp = pipelineJobsTemp.filter((x) =>
          jobNames.includes(x.name)
        );
      }
      pipelineJobsTemp = [
        ...new Map(
          pipelineJobs
            .filter(x => pipelineJobsTemp.some(y => y.id === x.id)) // Ensure jobs exist in orderedJobs
            .map(job => [job.id, job]) // Create a Map with unique IDs
        ).values()
      ];
      setOptions(pipelineJobsTemp);
    } else {
      let headers = await getHeaders();
      axios
        .get(`${BASE_URL}tools/jobs/all-jobs${showIsArchived !== null ? `?showIsArchived=${showIsArchived}` : ``}`, headers)
        .then((res) => {
          // Reset form fields (optional)
          if (jobNames && jobNames.length > 0) {
            res.data.data = res.data.data.filter((x) =>
              jobNames.includes(x.name)
            );
          }
          if (pipelineIds) {
            res.data.data = res.data.data.filter((x) => {
              return pipelineIds.map(x => Number(x)).includes(Number(x.pipeline_id))
            });
          }
          setOptions(res.data.data);
        })
        .catch((err) => {
          showAlert(err);
        });
    }
    
  };

  useEffect(() => {
    fetchJobs();
  }, [pipelineIds, pipelineJobs]);

  return (
    <Autocomplete
      sx={sx}
      multiple
      options={options}
      disableCloseOnSelect
      getOptionLabel={(option) =>
        `[${typeof option.pipeline_job_id === "number" ? option.pipeline_job_id : (option.pipeline_job_id ? (typeof option.pipeline_job_id === "number" ? option.pipeline_job_id : option.pipeline_job_id.slice(0, 4)) : (option.id ? (typeof option.id === "number" ? option.id : option.id.slice(0, 4)) : ` - `))}] ${option.pipeline_job_name ? `${option.pipeline_name} - ${option.name}` : option.name}`
      }
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox style={{ marginRight: 8 }} checked={selected} />
          {`[${typeof option.pipeline_job_id === "number" ? option.pipeline_job_id : (option.pipeline_job_id ? (typeof option.pipeline_job_id === "number" ? option.pipeline_job_id : option.pipeline_job_id.slice(0, 4)) : (option.id ? (typeof option.id === "number" ? option.id : option.id.slice(0, 4)) : ` - `))}] ${option.pipeline_job_name ? `${option.pipeline_name} - ${option.name}` : option.name}`}
        </li>
      )}
      style={width ? { width: width } : {}}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          margin="none"
        />
      )}
      value={selected}
      onChange={(event, newValue) => {
        onSelectedChange(newValue);
      }}
    />
  );
};

export default PipelineJobMultiSelect;
